// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> prairie-creek-apartments-townhomes
// Generated: 2026-11-03T23:01:11.855Z
// Counts: 1 design, 76 content, 5 slot group, 3 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing, Pets, Parking, and Community Information</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Prairie Creek Apartments &amp; Townhomes offers one-, two-, and three-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">apartments and townhomes for rent in Lenexa, KS</a>, located at 9395 Scarborough Street near 95th and Renner. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Apartments feature 9-foot ceilings, stainless steel appliances, a kitchen prep island, and a full-size washer and dryer. Select homes add a den or study, a garden-size soaking tub, or an attached garage with direct access. Need more space? Our <a class=\"richtext-link\" href=\"/floor-plans\">three-bedroom townhomes</a> offer more than 2,000 square feet.</p><p>Residents enjoy a saltwater swimming pool, an outdoor kitchen with a TV and fire pit, a 24-hour fitness center with a yoga room and on-site personal trainer, and monthly resident events. Prairie Creek is pet-friendly, with on-site walking trails for daily walks. Explore our <a class=\"richtext-link\" href=\"/amenities\">community and apartment amenities</a>, browse the <a class=\"richtext-link\" href=\"/gallery\">photo gallery</a>, or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> today.</p><p><strong>Spacious Townhomes With Two-Car Garages</strong></p><p>The townhomes at Prairie Creek Apartments &amp; Townhomes offer three bedrooms, an upstairs loft, an open-concept kitchen with living and dining areas, a spacious deck, and a finished lower-level bonus room with patio access. Every townhome includes an attached two-car garage and private driveway. <a class=\"richtext-link\" href=\"https://www.prairiecreekapartments.com/townhomes\"><u>Learn more about our townhomes</u></a>.</p>",
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartment Amenities in Lenexa, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities at Prairie Creek Apartments &amp; Townhomes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Prairie Creek Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3-Bedroom Apartments in Lenexa, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Prairie Creek Apartments &amp; Townhomes Photo Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pool, Sports Court, Townhomes and More </h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Prairie Creek Apartments &amp; Townhomes in Lenexa, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to Prairie Creek Apartments &amp; Townhomes</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Apartment Map in Lenexa, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Lenexa City Cente</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Preferred Employer Program at Prairie Creek Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Kiewit</p></li><li><p>Garmin</p></li><li><p>Geico</p></li><li><p>Active Military</p></li><li><p>AdventHealth</p></li><li><p>City of Lenexa</p></li><li><p>Quest Diagnostics</p></li><li><p>Hyland Software / Lexmark</p></li><li><p>Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Lenexa, K</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See what residents say about life at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour of Prairie Creek Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Prairie Creek Apartments &amp; Townhomes is managed by Price Brothers Management, a Kansas City family-owned company that has been managing apartment homes since 1922. If Prairie Creek doesn’t have the floor plan or location you need, our nearby communities, including [list nearby communities], offer more options across the Kansas City metro.</p><p>Explore each community’s location, floor plans, and pricing below, or<a class=\"richtext-link\" href=\"/contact-us\"> <u>contact the leasing team</u></a> with questions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Price Brothers Communities Near Prairie Creek Apartments &amp; Townhomes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Designed For Modern Luxury</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resort-Style Living, Every Day</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3> Live Near Lenexa City Center and 95th and Renner</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Virtual Tours in Lenexa, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions About Prairie Creek Apartments &amp; Townhomes<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span> Community</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Prairie Creek Apartments &amp; Townhomes offers one-, two-, and three-bedroom floor plans from 704 to 2,037 square feet, including three-bedroom townhomes. Every apartment includes 9-foot ceilings, stainless steel appliances, a full-size washer and dryer, and a deck. Select homes add a den or study, double sinks, a garden-size soaking tub, soft-close custom cabinets, plank flooring, or an attached one- or two-car garage with direct access.</p><ul><li><p><strong>One bedroom, one bath:</strong> Medina and Medina II (704 sq. ft.), Rio and Rio II (841 sq. ft.), Cimmaron and Cimmaron II (948 sq. ft.)</p></li><li><p><strong>Two bedroom, two bath:</strong> Sheyenne and Sheyenne II (1,090 sq. ft.), Cascade (1,210 sq. ft.), Savanna and Savanna II (1,372 sq. ft.)</p></li><li><p><strong>Three bedroom, two bath:</strong> Prairie and Prairie II (1,400 sq. ft.)</p></li><li><p><strong>Three-bedroom townhomes:</strong> Townhome (2,037 sq. ft.) and Townhome End Unit (2,002 sq. ft.)</p></li></ul><p>Pets are welcome, so review our <a class=\"richtext-link\" href=\"/amenities\">pet policy</a>, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> of Prairie Creek Apartments &amp; Townhomes.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "galleryseparator.image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_black_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_black_logo_media.alt_text"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_6a47ab6c6a40ff356f71dcfe",
      "ec_103c815f803e39ef30bf73bb",
      "ec_bdbd5b34cc0c4705a85f4a93",
      "ec_1e2a108ac9a643760fd6698e",
      "ec_7bebf785e21bd5f003b3cdf6",
      "ec_a1eaaf19b129a1919e2b1046",
      "ec_8b1ec6623a958fb6b0b46071",
      "ec_7ff2e4d15833fff204faf93b",
      "ec_3ccc13bafeb64f360182fa4c",
      "ec_8f3406a3a70f92dbff00fff3",
      "ec_163f6a860f82214675974b18",
      "ec_919109b83aba10865dc75773",
      "ec_b7b50059ec957d7666775bf9",
      "ec_d720242cae78b8c1e751ffb7",
      "ec_c89dfb637ea411e6fabfe0cf",
      "ec_7089b611206b163d5ff23324",
      "ec_8a84c977fd7f5bd3525d287f",
      "ec_c12ae7bb62529b30e9f86bc9",
      "ec_4b3c26c1a8aa7cce3915a589",
      "ec_ef7ef1bd9edd336457bc1a88",
      "ec_8bc6814985affeb41093a386",
      "ec_1c059809453a505131692c9c",
      "ec_40c5010203d90b8cb3465196",
      "ec_5f80e74c5327a0fdc125fddd",
      "ec_5eddc21a05f1f90761ae1c7e",
      "ec_f2a0bd490ddeda0f378742e6"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallerycommunity.images": {
    "limit": null,
    "hiddenIds": [
      "ec_6a47ab6c6a40ff356f71dcfe"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_4acab25a6cb57302011e4ee9"
    ],
    "orderedIds": [
      "ec_b7b50059ec957d7666775bf9",
      "ec_3ccc13bafeb64f360182fa4c",
      "ec_163f6a860f82214675974b18",
      "ec_40c5010203d90b8cb3465196",
      "ec_7089b611206b163d5ff23324",
      "ec_919109b83aba10865dc75773",
      "ec_8a84c977fd7f5bd3525d287f",
      "ec_c89dfb637ea411e6fabfe0cf",
      "ec_c12ae7bb62529b30e9f86bc9",
      "ec_6a47ab6c6a40ff356f71dcfe",
      "ec_d720242cae78b8c1e751ffb7",
      "ec_103c815f803e39ef30bf73bb",
      "ec_a1eaaf19b129a1919e2b1046",
      "ec_8b1ec6623a958fb6b0b46071",
      "ec_5f80e74c5327a0fdc125fddd",
      "ec_bdbd5b34cc0c4705a85f4a93",
      "ec_ebde3e606775ccc1c32624de",
      "ec_7bebf785e21bd5f003b3cdf6",
      "ec_f2a0bd490ddeda0f378742e6",
      "ec_4b3c26c1a8aa7cce3915a589",
      "ec_ef7ef1bd9edd336457bc1a88",
      "ec_1e2a108ac9a643760fd6698e",
      "ec_8bc6814985affeb41093a386",
      "ec_1c059809453a505131692c9c",
      "ec_7ff2e4d15833fff204faf93b",
      "ec_530622b182674d0cbcb9b887",
      "ec_6abb4893d7116e9a3509ea53",
      "ec_1b3e3cec0c8c16f1a16f287b",
      "ec_bf8f8bd9cc5c4cc9f594cfe2",
      "ec_a06e613453977e3bb226f174",
      "ec_4acab25a6cb57302011e4ee9",
      "ec_138491a7150fbec3ba48ddbf",
      "ec_550c1d23a48f322d7515085f",
      "ec_851e709ca59e4968c3a2a24d",
      "ec_4d9b099dbcc65750c094b005",
      "ec_4d40fefcbdf597e6e63f4e5d",
      "ec_d699fb4e8af659d0e8fb5570",
      "ec_8ea680ce034794cd76591778",
      "ec_014acb6c0e370441e1ceac5f",
      "ec_32afdecb7dcca141623d5120",
      "ec_e0d29a79b903bc3be2795c2f",
      "ec_abc904c89baf2b0bd3c3e01f",
      "ec_5eddc21a05f1f90761ae1c7e",
      "ec_ec64b1579c16cfee241e0618",
      "ec_ad7783b6268fca9addc66baf",
      "ec_12263d30dec872b6545f58db",
      "ec_8b6389acc29fc95005cb0b5f",
      "ec_b62bdacfd94d541bd349f72b",
      "ec_9cfbd940ef09ab359831321a",
      "ec_0b99fb08344864c6b2ace602",
      "ec_925bbba48525cc701f2ff5e9",
      "ec_8f3406a3a70f92dbff00fff3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  }
};
